const steelClasses = [
    {
        name: 'S235',
        fyk: 235
    },
    {
        name: 'S275',
        fyk: 275
    },
    {
        name: 'S355',
        fyk: 355
    },
    {
        name: 'S460',
        fyk: 460
    }
]

export default steelClasses;